'use strict';

import Chart from 'chart.js';
import {Area, Font} from '@/features/reports/components/chartjs/plugins/doughnutLabels/types';

const helpers = Chart.helpers;

const utils = {

	parseFont: (value: any): Font => {
		const global = Chart.defaults.global;
		const size = helpers.valueOrDefault(value.size, global.defaultFontSize);
		const font = {
			family: helpers.valueOrDefault(value.family, global.defaultFontFamily),
			lineHeight: helpers.options.toLineHeight(value.lineHeight, size),
			size,
			style: helpers.valueOrDefault(value.style, global.defaultFontStyle),
			weight: helpers.valueOrDefault(value.weight, null),
			string: ''
		};

		font.string = utils.toFontString(font);
		return font;
	},

	toFontString: (font: any): string => {
		if (!font || helpers.isNullOrUndef(font.size) || helpers.isNullOrUndef(font.family)) {
			return '';
		}

		return (font.style ? font.style + ' ' : '')
			+ (font.weight ? font.weight + ' ' : '')
			+ font.size + 'px '
			+ font.family;
	},

	textSize: (ctx: CanvasRenderingContext2D, labels: any[]): Area => {
		const prev = ctx.font;
		let width = 0;
		let height = 0;

		for (const item of labels) {
			ctx.font = item.font.string;
			width = Math.max(ctx.measureText(item.text).width, width);
			height += (item.font.lineHeight || 24);
		}

		ctx.font = prev;
		return { height, width };
	}

};

export default utils;
